// src/pages/home/LocationButton.js
import React, { useState, useEffect } from 'react';
import './LocationButton.css';

const allLocations = ['In Foster', 'Manhattan', 'Westhampton', 'Wantagh'];

const LocationButton = ({ onSelect }) => {
  const [currentLocation, setCurrentLocation] = useState('In Foster');
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const savedLocation = localStorage.getItem('selectedLocation');
    if (savedLocation) {
      setCurrentLocation(savedLocation);
    }
  }, []);

  const handleSelect = (loc) => {
    setCurrentLocation(loc);
    localStorage.setItem('selectedLocation', loc);
    setMenuOpen(false);

    if (onSelect) {
      onSelect(loc); // ✅ Notify parent component
    }
  };

  const filteredLocations = allLocations.filter((loc) => loc !== currentLocation);

  return (
    <div className="location-selector">
      <button onClick={() => setMenuOpen(!menuOpen)}>
        <span className="triangle">▾</span>
        <span>{currentLocation}</span>
      </button>
      {menuOpen && (
        <ul className="home-location-dropdown">
          {filteredLocations.map((loc) => (
            <li key={loc} onClick={() => handleSelect(loc)}>
              {loc}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default LocationButton;
